import { Route, Routes } from 'react-router-dom';
import UsersList from './users-list';
import EndUserProfileView from './view-end-user-profile';

const UsersBase = () => (
  <Routes>
    <Route path="/" element={<UsersList />} />
    <Route path="/:id" element={<EndUserProfileView />} />
  </Routes>
);

export default UsersBase;
